import React from 'react';
import moment from 'moment';

import {
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Button,
    Link,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import { Typography, Avatar } from '@mui/material';

import Icon from '@mdi/react';
import { mdiMap } from '@mdi/js';

import { useDispatch, useSelector } from 'react-redux';
import { setEventDetailView, removeEventDetailView, eventDetailViewSelector, getEventAddress } from '../../features/events/eventsSlice';
import { removeDetailView, selectAssetNameById } from '../../features/assets/assetsSlice';
import { setCenter, setMapControl, setZoom } from '../../features/map/mapSlice';
import eventIcons from '../../utils/eventIcons.js';

const useStyles = makeStyles((theme) => ({
    active: {
        backgroundColor: 'Beige'
    },
    inactive: {
        backgroundColor: 'White'
    }

}));


const EventListItem = ({ eventId, eventForAssetID }) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const eventDetailView = useSelector(eventDetailViewSelector);
    const eventData = useSelector(state => state.events.eventContent[`${eventId}`]);
    const assetID = eventData ? `${eventData.assetID}` : null;
    const assetName = useSelector(state => selectAssetNameById(state, assetID));
    const regn = assetName && assetName.regn;

    const toggleEventDetails = () => {
        if (eventId === eventDetailView) {
            dispatch(removeEventDetailView());
            dispatch(setMapControl('asset'));
        } else {
            dispatch(removeDetailView());
            dispatch(getEventAddress({
                searchParam: {
                    eventId: eventId,
                    lat: eventData.lat,
                    lng: eventData.lng,
                    regn: regn,
                }
            }));
            dispatch(setEventDetailView(eventId));
            dispatch(setCenter({
                lat: parseFloat(eventData.lat),
                lng: parseFloat(eventData.lng),
            }));
            dispatch(setZoom(17));
            dispatch(setMapControl('event'));
        }

    }

    const eventCard = () => (
        <ListItem
            className={eventId === eventDetailView ? classes.active : classes.inactive}
        >
            <ListItemAvatar>
                <Avatar
                    style={{ backgroundColor: 'Ivory' }}
                >
                    {eventIcons(eventData.event_desc)}
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={
                    <Link href="#" onClick={toggleEventDetails}>
                        <Typography
                            variant="body1"
                            color='textPrimary'
                        >
                            <span>
                                <b>
                                    {eventData.event_desc}
                                </b>
                            </span>
                        </Typography>
                    </Link>
                }
                secondary={
                    <Typography
                        variant="body2"
                        color='textPrimary'
                    >
                        {regn} <br /> {`${moment(eventData.event_time).format("Do MMM YY hh:mm:ss A")}`}
                    </Typography>
                }
            />
            <ListItemSecondaryAction>
                <Button onClick={toggleEventDetails}>
                    <Icon
                        path={mdiMap}
                        title="Show Map"
                        size={0.7}
                        color="Grey"

                    />
                </Button>

            </ListItemSecondaryAction>
        </ListItem>
    );

    if (eventForAssetID) {
        if (eventForAssetID === assetID) {
            if (eventData && regn) {
                return eventCard();
            } else {
                return null;
            }
        } else {
            return null;
        }

    } else {
        if (eventData && regn) {
            return eventCard();
        } else {
            return null;
        }
    }

}

export default React.memo(EventListItem);